import { coverageStats } from '../../../mocks/serviceAreas';

export default function ServiceHero() {
  return (
    <section className="relative pt-28 pb-20 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1ef89fb3cb49ea145b401599a8ea0147.jpg"
          alt="Florida service coverage area"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-navy/80 via-brand-navy/70 to-brand-navy/90"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-brand-gold font-semibold text-sm uppercase tracking-widest mb-4">
            Service Coverage
          </span>
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Serving Florida Homeowners <span className="text-brand-gold">Statewide</span>
          </h1>
          <p className="text-lg text-white/80 leading-relaxed">
            From Miami to Tampa Bay, we bring expert HVAC, solar, and insulation services to communities across the Sunshine State. Find your area below.
          </p>
        </div>

        {/* Stats bar */}
        <div className="bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 p-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {coverageStats.map((stat, i) => (
              <div key={i} className="text-center">
                <p className="text-3xl lg:text-4xl font-bold text-white mb-1">{stat.value}</p>
                <p className="text-sm text-white/70 font-medium uppercase tracking-wide">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
